/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelOrderCurrentMoveStops.ts         *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/integrations/order-current-move-stops";

export class AutogenModelOrderCurrentMoveStops<RowType extends ModelRow> extends Endpoint<RowType, RowOrderCurrentMoveStopsFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowOrderCurrentMoveStops extends ModelRow<RowOrderCurrentMoveStopsFields> {
	constructor(values?: Partial<RowOrderCurrentMoveStopsFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowOrderCurrentMoveStopsFields {
	actual_reefer_profile: string;
	agency_id: string;
	agent_payee_id: string;
	all_vendors_enabled: string;
	allow_relay: string;
	autorate_status: string;
	bill_date: Date;
	bill_distance: number;
	bill_distance_um: string;
	billing_empty_distance: number;
	billing_empty_distance_um: string;
	billing_loaded_distance: number;
	billing_loaded_distance_um: string;
	billing_user_id: string;
	blnum: string;
	bol_note: string;
	bol_received: string;
	bol_recv_date: Date;
	booking_no: string;
	booking_number: string;
	brk_qual_profile: string;
	broker_location_id: string;
	brokerage_workflow_id: string;
	carrier_scorecard_export_dt: Date;
	carrier_scorecard_exported: string;
	cbp_crossing_date: Date;
	cbp_crossing_location_id: string;
	cbp_crossing_reason: string;
	cbsa_crossing_date: Date;
	cbsa_crossing_location_id: string;
	cbsa_crossing_reason: string;
	cc_fuel_revenue: number;
	cc_fuel_revenue_c: string;
	cc_fuel_revenue_d: Date;
	cc_fuel_revenue_n: number;
	cc_fuel_revenue_r: number;
	cc_net_revenue: number;
	cc_net_revenue_c: string;
	cc_net_revenue_d: Date;
	cc_net_revenue_n: number;
	cc_net_revenue_r: number;
	cc_pro_nbr: string;
	cobroker_location_id: string;
	collection_method: string;
	com_setpnt_temp: number;
	com_setpnt_temp_dt: Date;
	com_setpnt_temp_um: string;
	commitment_id: string;
	commodity: string;
	commodity_id: string;
	company_id: string;
	consignee_refno: string;
	consignee_stop_id: string;
	container: string;
	container_planned: string;
	container_type_id: string;
	controlling_carrier_code: string;
	copy_from_company: string;
	copy_from_order_id: string;
	copy_to_company: string;
	copy_to_order_id: string;
	ctrl_party_id: string;
	cube: number;
	curr_movement_id: string;
	cust_order_no: string;
	customer_id: string;
	dat_loadboard_refid: string;
	declared_val: number;
	def_move_type: string;
	default_match_id: string;
	dim_height: string;
	dim_length: string;
	dim_surcharge: number;
	dim_surcharge_c: string;
	dim_surcharge_d: Date;
	dim_surcharge_n: number;
	dim_surcharge_r: number;
	dim_width: string;
	dispatch_opt: string;
	dl_team_reqd: string;
	dray_del_date: Date;
	dray_del_pay: number;
	dray_del_pay_c: string;
	dray_del_pay_d: Date;
	dray_del_pay_n: number;
	dray_del_pay_r: number;
	dray_del_payee: string;
	dray_del_xfer_dt: Date;
	dray_pu_date: Date;
	dray_pu_pay: number;
	dray_pu_pay_c: string;
	dray_pu_pay_d: Date;
	dray_pu_pay_n: number;
	dray_pu_pay_r: number;
	dray_pu_payee: string;
	dray_pu_xfer_dt: Date;
	eir1_no: string;
	eir2_no: string;
	entered_user_id: string;
	equipment_type_id: string;
	equipment_type_options: string;
	est_tolls: number;
	est_tolls_c: string;
	est_tolls_d: Date;
	est_tolls_n: number;
	est_tolls_r: number;
	excise_disable_update: string;
	excise_taxable: string;
	excisetax_total: number;
	excisetax_total_c: string;
	excisetax_total_d: Date;
	excisetax_total_n: number;
	excisetax_total_r: number;
	external_invoiceno: string;
	extra_deliveries: number;
	extra_pickups: number;
	floor_loaded_freight: string;
	force_assign: string;
	forwd_location_id: string;
	free_days: number;
	freight_charge: number;
	freight_charge_c: string;
	freight_charge_d: Date;
	freight_charge_n: number;
	freight_charge_r: number;
	hazmat: string;
	hazmat_code: string;
	high_value: string;
	hold_reason: string;
	ic_company_from: string;
	ic_movement_from: string;
	ic_order_from: string;
	id: string;
	image_is_present: string;
	import_export: string;
	include_split_point: string;
	intelliset: string;
	invoice_recv_date: Date;
	is_auto_tonu: string;
	is_autorate_dist: string;
	is_container: string;
	is_dedicated: string;
	is_intercompany: string;
	is_local_mile: string;
	is_requested: string;
	is_tonu: string;
	jag_carrier_id: string;
	jag_cost_rate_id: number;
	ldport_location_id: string;
	linear_feet_avail: number;
	load_date: Date;
	loadboard: string;
	loadboard_last_refresh: Date;
	loadboard_post_movement_id: string;
	loadboard_posting_cancelled: string;
	lock_miles: string;
	ltl: string;
	markup_flat: number;
	markup_flat_c: string;
	markup_flat_d: Date;
	markup_flat_n: number;
	markup_flat_r: number;
	markup_percent: number;
	master_order_id: string;
	master_sequence: number;
	"movement.additional_customer_tag": string;
	"movement.additional_global_tag": string;
	"movement.authorized": string;
	"movement.average_broker_rating": number;
	"movement.booking_no": string;
	"movement.br_details_link": string;
	"movement.br_status_link": string;
	"movement.br_track_interval": number;
	"movement.br_track_status": string;
	"movement.br_track_status_desc": string;
	"movement.br_track_vehicle_id": string;
	"movement.br_tracking_id": string;
	"movement.br_vendor": string;
	"movement.broker_avail_tract": string;
	"movement.brokerage": string;
	"movement.brokerage_status": string;
	"movement.buy_to_market_ex": string;
	"movement.carrier_contact": string;
	"movement.carrier_email": string;
	"movement.carrier_empty_from_city_id": number;
	"movement.carrier_fuel_pay_rate_id": number;
	"movement.carrier_lane_rate_id": string;
	"movement.carrier_override_carrier": string;
	"movement.carrier_override_user": string;
	"movement.carrier_phone": string;
	"movement.carrier_rate_id": number;
	"movement.carrier_scorecard_export_dt": Date;
	"movement.carrier_scorecard_exported": string;
	"movement.carrier_tractor": string;
	"movement.carrier_trailer": string;
	"movement.carrier_trailer_type": string;
	"movement.chassis": string;
	"movement.checkcall_sched_id": string;
	"movement.company_id": string;
	"movement.container": string;
	"movement.container_returned": string;
	"movement.container_status": string;
	"movement.controlling_carrier_code": string;
	"movement.dedicated_order_id": string;
	"movement.dest_stop_id": string;
	"movement.dfm_user": string;
	"movement.digital_booking": string;
	"movement.dispatcher_user_id": string;
	"movement.eform_rate_confirmation": string;
	"movement.empty2next_order": string;
	"movement.equipment_group_id": string;
	"movement.est_tolls": number;
	"movement.est_tolls_c": string;
	"movement.est_tolls_d": Date;
	"movement.est_tolls_n": number;
	"movement.est_tolls_r": number;
	"movement.exclude_movement": string;
	"movement.fleet_manager": string;
	"movement.freight_matching_override": string;
	"movement.fuel_distance": number;
	"movement.fuel_distance_um": string;
	"movement.fuel_tax_exempt": string;
	"movement.geo_override_mins": number;
	"movement.has_load_lock_alert": string;
	"movement.hubtran_approved_inv_date": Date;
	"movement.hubtran_ok2pay_date": Date;
	"movement.ic_company_to": string;
	"movement.ic_order_to": string;
	"movement.id": string;
	"movement.integrated_carrier_search": string;
	"movement.invitation_date": Date;
	"movement.invoice_recv_date": Date;
	"movement.is_container": string;
	"movement.is_dfm_tracking": string;
	"movement.is_dray": string;
	"movement.is_intercompany": string;
	"movement.is_local_mile": string;
	"movement.linked_id": number;
	"movement.linked_sequence": number;
	"movement.load_booking_eligible": string;
	"movement.load_booking_source": string;
	"movement.loaded": string;
	"movement.locked_user_id": string;
	"movement.ltl": string;
	"movement.ltl_staging_wrs_uid": number;
	"movement.macropoint_status": string;
	"movement.manifest_empty_distance": number;
	"movement.manifest_estimated_arrival": Date;
	"movement.manifest_estimated_depart": Date;
	"movement.manifest_hold": string;
	"movement.manifest_id": string;
	"movement.manifest_loaded_distance": number;
	"movement.manifest_reg_uid": number;
	"movement.manifest_spots_capacity": number;
	"movement.manifest_spots_consumed": number;
	"movement.manifest_weight_capacity": number;
	"movement.manifest_weight_consumed": number;
	"movement.max_buy": number;
	"movement.max_buy_c": string;
	"movement.max_buy_d": Date;
	"movement.max_buy_n": number;
	"movement.max_buy_r": number;
	"movement.max_pay_method": string;
	"movement.max_pay_units": number;
	"movement.missed_call_sent": string;
	"movement.move_distance": number;
	"movement.move_distance_um": string;
	"movement.movement_type": string;
	"movement.must_respond_by": Date;
	"movement.next_sched_call": Date;
	"movement.operational_status": string;
	"movement.operations_user": string;
	"movement.origin_stop_id": string;
	"movement.override_crny_type": string;
	"movement.override_driver2_id": number;
	"movement.override_driver2_nm": string;
	"movement.override_driver_id": number;
	"movement.override_driver_nm": string;
	"movement.override_drvr2_cell": string;
	"movement.override_drvr2_country_code": string;
	"movement.override_drvr2_email": string;
	"movement.override_drvr_cell": string;
	"movement.override_drvr_country_code": string;
	"movement.override_drvr_email": string;
	"movement.override_max_pay": number;
	"movement.override_max_pay_c": string;
	"movement.override_max_pay_d": Date;
	"movement.override_max_pay_n": number;
	"movement.override_max_pay_r": number;
	"movement.override_pay_amt": number;
	"movement.override_pay_amt_c": string;
	"movement.override_pay_amt_d": Date;
	"movement.override_pay_amt_n": number;
	"movement.override_pay_amt_r": number;
	"movement.override_pay_rate": number;
	"movement.override_paye_rate": number;
	"movement.override_payee_id": string;
	"movement.override_targetpay": number;
	"movement.override_targetpay_c": string;
	"movement.override_targetpay_d": Date;
	"movement.override_targetpay_n": number;
	"movement.override_targetpay_r": number;
	"movement.override_type": string;
	"movement.override_unit_desc": string;
	"movement.override_units": number;
	"movement.pay_distance": number;
	"movement.pay_distance_um": string;
	"movement.pending_carrier_city": string;
	"movement.pending_carrier_name": string;
	"movement.pending_carrier_nbr": string;
	"movement.pending_carrier_phone": string;
	"movement.pending_carrier_state": string;
	"movement.pending_carrier_type": string;
	"movement.pending_carrier_zip": string;
	"movement.pending_invite_conf": string;
	"movement.pending_payee_id": string;
	"movement.placard_required": string;
	"movement.preassign_sequence": number;
	"movement.priority": string;
	"movement.pro_nbr": string;
	"movement.rate_alert_basis": string;
	"movement.rate_alert_date": Date;
	"movement.rate_alert_days": number;
	"movement.rate_alert_hours": number;
	"movement.rate_alert_minutes": number;
	"movement.rate_confirm_template": number;
	"movement.rate_confirmation_sent_date": Date;
	"movement.rate_confirmation_status": string;
	"movement.rate_expiration_basis": string;
	"movement.rate_expiration_date": Date;
	"movement.rate_expiration_days": number;
	"movement.rate_expiration_hours": number;
	"movement.rate_expiration_minutes": number;
	"movement.rdy_pickup_date": Date;
	"movement.recurring_movement_id": string;
	"movement.reminder_sent": string;
	"movement.require_tracking": string;
	"movement.required_vendor": string;
	"movement.reserved": string;
	"movement.return_date": Date;
	"movement.seg_alloc_code": string;
	"movement.shipper_email": string;
	"movement.shipper_notify_frequency": string;
	"movement.shpmt_ident_type": string;
	"movement.shpmt_ident_value": string;
	"movement.ss_location_id": string;
	"movement.status": string;
	"movement.target_extra_stop_pay": number;
	"movement.target_extra_stop_pay_c": string;
	"movement.target_extra_stop_pay_d": Date;
	"movement.target_extra_stop_pay_n": number;
	"movement.target_extra_stop_pay_r": number;
	"movement.target_fuel_surcharge_pay": string;
	"movement.target_pay": number;
	"movement.target_pay_c": string;
	"movement.target_pay_d": Date;
	"movement.target_pay_method": string;
	"movement.target_pay_n": number;
	"movement.target_pay_r": number;
	"movement.target_pay_units": number;
	"movement.target_rate_data": string;
	"movement.target_rate_id": number;
	"movement.time_to_send_msg": Date;
	"movement.track_start_date": Date;
	"movement.tracking_duration_ext": number;
	"movement.tracking_notify_email": string;
	"movement.tracking_request_status": string;
	"movement.trailer_rent_pct": number;
	"movement.trip_lease": string;
	"movement.trip_mgt_recalc_datetime": Date;
	"movement.trip_mgt_tracking_id": string;
	"movement.triumphpay_exclude": string;
	"movement.trp_uid": number;
	"movement.ts_borrowing_company": string;
	"movement.ts_commodity": string;
	"movement.ts_movement_id": string;
	"movement.unlock_time": Date;
	"movement.waterfall_flood_time": Date;
	"movement.waterfall_in_progress": string;
	"movement.xfer2settle_date": Date;
	"movement.xferred2fueltax": string;
	"movement.xferred2fueltaxdt": Date;
	"movement.xmit_accepted": string;
	"movement.xmitted2driver": Date;
	"movement.zmit_trip": string;
	next_rebill: string;
	nte_lp_num: string;
	nte_lp_qual: string;
	on_hold: string;
	operational_status: string;
	operations_user: string;
	optimize: string;
	optiset: string;
	order_length: number;
	order_mode: string;
	order_type_id: string;
	order_value: number;
	order_value_c: string;
	order_value_d: Date;
	order_value_n: number;
	order_value_r: number;
	ordered_by: string;
	ordered_by_id: string;
	ordered_date: Date;
	ordered_method: string;
	orig_dest_rate_id: string;
	otherchargetotal: number;
	otherchargetotal_c: string;
	otherchargetotal_d: Date;
	otherchargetotal_n: number;
	otherchargetotal_r: number;
	override_arrive_early: Date;
	override_arrive_late: Date;
	override_posting_city_id: number;
	pallets_how_many: number;
	pallets_required: string;
	pay_gross: number;
	pay_gross_c: string;
	pay_gross_d: Date;
	pay_gross_n: number;
	pay_gross_r: number;
	pick_up_no: string;
	pieces: number;
	placard_required: string;
	planning_comment: string;
	pnn_callback: string;
	pnn_comment: string;
	pnn_comment2: string;
	pnn_loadboard_user_id: string;
	pnn_post_type: string;
	pnn_rate: number;
	pnn_rate_type: string;
	pnn_trailer_length: number;
	pnn_trailer_width: number;
	ponum: string;
	port: string;
	port_of_discharge: string;
	preferred_vendors: string;
	preload_trailer_id: string;
	preloaded: string;
	rate: number;
	rate_currency_type: string;
	rate_id: number;
	rate_min_weight: number;
	rate_min_weight_um: string;
	rate_source: string;
	rate_type: string;
	rate_unit_desc: string;
	rate_units: number;
	ready_to_bill: string;
	recurring_order_id: string;
	reply_transmitted: string;
	requesting_company: string;
	return_temp: number;
	return_temp_dt: Date;
	return_temp_um: string;
	return_temp_var: number;
	return_temp_var_um: string;
	revenue_code_id: string;
	revenue_share_method: string;
	round_trip: string;
	sail_date: Date;
	seal_number: string;
	seg_alloc_code: string;
	setpoint_temp: number;
	setpoint_temp_um: string;
	setpoint_var: number;
	setpoint_var_um: string;
	ship_status_to_edi: string;
	shipment_id: string;
	shipper_stop_id: string;
	shipstatus2edi_dt: Date;
	ss_location_id: string;
	status: string;
	subject_order_number: string;
	subject_order_status: string;
	subject_order_void_date: Date;
	swap: string;
	teams_required: string;
	temperature_max: number;
	temperature_max_um: string;
	temperature_min: number;
	temperature_min_um: string;
	temperature_um: string;
	total_charge: number;
	total_charge_c: string;
	total_charge_d: Date;
	total_charge_n: number;
	total_charge_r: number;
	totalcharge_and_excisetax: number;
	totalcharge_and_excisetax_c: string;
	totalcharge_and_excisetax_d: Date;
	totalcharge_and_excisetax_n: number;
	totalcharge_and_excisetax_r: number;
	tractor_type: string;
	vessel: string;
	vessel_cutoff_date: Date;
	voided_load_transmitted: string;
	voided_load_transmitted_dt: Date;
	weight: number;
	weight_um: string;
	xferred2billing: string;
	xferred2billing_dt: Date;
}

